import { getAuth, applyActionCode } from "firebase/auth";
import { app } from "../firebase-config.js";

export const WelcomePage = async () => {
    const container = document.createElement('div');
    container.className = "relative flex items-center justify-center min-h-screen w-full overflow-hidden bg-gray-900";

    // Extract oobCode from URL
    const urlParams = new URLSearchParams(window.location.search);
    const mode = urlParams.get('mode');
    const actionCode = urlParams.get('oobCode');

    // UI State Manager
    const render = (state, message = "") => {
        let content = "";

        if (state === 'loading') {
            content = `
                <div class="relative z-10 w-full max-w-lg p-6 animate-fade-in-up">
                    <div class="bg-black/30 backdrop-blur-md border border-white/20 rounded-3xl p-10 text-center shadow-2xl">
                        <!-- Spinner -->
                        <div class="mb-8 relative inline-block">
                            <div class="w-20 h-20 border-4 border-indigo-500/30 border-t-indigo-500 rounded-full animate-spin"></div>
                            <div class="absolute inset-0 flex items-center justify-center">
                                <span class="material-symbols-outlined text-3xl text-indigo-400 animate-pulse">rocket_launch</span>
                            </div>
                        </div>
                        <h1 class="text-2xl font-bold text-white mb-2">차원 진입 코드 확인 중...</h1>
                        <p class="text-indigo-200">Verifying Ticket...</p>
                    </div>
                </div>
            `;
        } else if (state === 'success') {
            content = `
                <div class="relative z-10 w-full max-w-lg p-6 animate-fade-in-up">
                    <div class="bg-black/30 backdrop-blur-md border border-white/20 rounded-3xl p-10 text-center shadow-2xl">
                        <div class="mb-8 relative inline-block animate-float">
                            <div class="w-24 h-24 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shadow-lg shadow-indigo-500/50">
                                <span class="material-symbols-outlined text-5xl text-white">verified_user</span>
                            </div>
                            <div class="absolute inset-0 bg-indigo-500 blur-xl opacity-30 rounded-full animate-pulse"></div>
                        </div>
                        <h1 class="text-3xl font-bold text-white mb-2 tracking-tight">차원 이동 승인 완료</h1>
                        <p class="text-indigo-200 font-medium mb-8">Verification Successful</p>
                        <div class="w-16 h-1 bg-gradient-to-r from-transparent via-indigo-500 to-transparent mx-auto mb-8 opacity-50"></div>
                        <p class="text-gray-300 leading-relaxed mb-10">
                            여행자님의 신분이 확인되었습니다.<br>
                            이제 <strong class="text-white">SSULWHA 월드</strong>의 모든 우주적 기능을<br>
                            제한 없이 이용하실 수 있습니다.
                        </p>
                        <button id="btn-enter" class="w-full py-4 rounded-2xl bg-gradient-to-r from-indigo-600 to-pink-600 hover:from-indigo-500 hover:to-pink-500 text-white font-bold text-lg shadow-xl shadow-indigo-500/30 transition-all transform hover:scale-[1.02] active:scale-[0.98] group">
                            <span class="flex items-center justify-center gap-2">
                                SSULWHA 월드 입장하기
                                <span class="material-symbols-outlined group-hover:translate-x-1 transition-transform">arrow_forward</span>
                            </span>
                        </button>
                    </div>
                </div>
            `;
        } else if (state === 'error') {
            content = `
                <div class="relative z-10 w-full max-w-lg p-6 animate-fade-in-up">
                    <div class="bg-black/30 backdrop-blur-md border border-red-500/30 rounded-3xl p-10 text-center shadow-2xl">
                        <div class="mb-8 relative inline-block">
                             <span class="material-symbols-outlined text-6xl text-red-500">error_outline</span>
                        </div>
                        <h1 class="text-2xl font-bold text-white mb-2">승인 실패</h1>
                        <p class="text-red-300 mb-6">${message}</p>
                        <button onclick="window.router.navigate('/')" class="px-6 py-3 rounded-xl bg-white/10 hover:bg-white/20 text-white transition-colors">
                            홈으로 돌아가기
                        </button>
                    </div>
                </div>
            `;
        }

        container.innerHTML = `
            <div class="absolute inset-0 z-0">
                <div class="absolute inset-0 bg-black/20 z-10"></div>
                <img src="/login.webp" class="w-full h-full object-cover" alt="Background">
            </div>
            ${content}
            <div class="relative z-10 text-center mt-8 opacity-60">
                 <img src="/logo.png" class="h-6 mx-auto invert opacity-80" alt="">
            </div>
        `;

        if (state === 'success') {
            setTimeout(() => {
                const btn = container.querySelector('#btn-enter');
                if (btn) {
                    btn.onclick = () => {
                        const auth = getAuth(app);
                        if (auth.currentUser) {
                            // Already logged in -> Go Home
                            window.router.navigate('/');
                        } else {
                            // Not logged in -> Go Login
                            // We can use sessionStorage to show a toast on login page if we want
                            // But for now simple redirect
                            window.router.navigate('/login');
                        }
                    };
                }
            }, 0);
        }
    };

    // Main Logic
    // If no code, just show success (Preview Mode) or redirect
    if (!actionCode) {
        // Assume preview mode or already verified redirect
        render('success');
    } else {
        render('loading');
        try {
            const auth = getAuth(app);
            await applyActionCode(auth, actionCode);
            render('success');
        } catch (error) {
            console.error(error);
            let msg = "유효하지 않거나 이미 만료된 코드입니다.";
            if (error.code === 'auth/expired-action-code') msg = "승인 코드가 만료되었습니다. 다시 시도해주세요.";
            if (error.code === 'auth/invalid-action-code') msg = "잘못된 승인 코드입니다.";
            if (error.code === 'auth/user-disabled') msg = "비활성화된 계정입니다.";
            if (error.code === 'auth/user-not-found') msg = "사용자를 찾을 수 없습니다.";
            render('error', msg);
        }
    }

    return container;
};
